<div class="min-h-screen bg-slate-50 cg-mkt-page">
  @let ann = announcement();
  @if (ann !== undefined && ann.text) {
    <app-marketing-announcement
      [pill]="ann.pill"
      [text]="ann.text"
      [ctaLabel]="ann.ctaLabel"
      [ctaHref]="ann.ctaHref"
    />
  }
  <main class="relative flex min-h-[50vh] flex-col">
    <router-outlet #primaryOutlet="outlet" />
    @if (!primaryOutlet.isActivated) {
      <div
        class="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 bg-slate-50 text-slate-500"
        aria-busy="true"
        aria-live="polite"
      >
        <span
          class="h-10 w-10 animate-spin rounded-full border-2 border-slate-300 border-t-slate-700"
          aria-hidden="true"
        ></span>
        <p class="text-sm">Loading…</p>
      </div>
    }
  </main>
</div>
